import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import PropTypes from 'prop-types';
import React from 'react';
import SecondaryButton from '../SecondaryButton';

class ReportDownload extends React.Component {

    state = {
        open: false
    };

    downloadReport = (format, includeHeaders) => this.props.onDownloadReport(format, includeHeaders);

    showMenu = (ev) => {
        this.setState({
            anchorEl: ev.currentTarget,
            open: true
        });
    };

    handleClose = (format, includeHeaders = false) => {
        this.setState({ open: false });
        if (format !== null) this.downloadReport(format, includeHeaders);
    };

    render() {

        const { disabled } = this.props;
        const { open, anchorEl } = this.state;

        return (
            <div>
                <SecondaryButton
                    disabled={disabled}
                    dataTest="download-report"
                    endIcon={<KeyboardArrowDownIcon />}
                    onClick={this.showMenu}>Download</SecondaryButton>
                <Menu
                    open={open}
                    anchorEl={anchorEl}
                    transformOrigin={{
                        horizontal: -5,
                        vertical: -46
                    }}
                    onClose={(ev) => {
                        ev.preventDefault();
                        ev.stopPropagation();
                        this.handleClose(null);
                    }}>
                    <MenuItem
                        data-test={"item-csv"}
                        dense={true}
                        onClick={(ev) => {
                            ev.preventDefault();
                            ev.stopPropagation();
                            this.handleClose("csv");
                        }}
                        value="csv">CSV</MenuItem>
                    <MenuItem
                        data-test={"item-csv-headers"}
                        dense={true}
                        onClick={(ev) => {
                            ev.preventDefault();
                            ev.stopPropagation();
                            this.handleClose("csv", true);
                        }}
                        value="csv">CSV including Header Row</MenuItem>
                    <MenuItem
                        data-test={"item-html"}
                        dense={true}
                        onClick={(ev) => {
                            ev.preventDefault();
                            ev.stopPropagation();
                            this.handleClose("html");
                        }}
                        value="html">HTML</MenuItem>
                    <MenuItem
                        data-test={"item-html-headers"}
                        dense={true}
                        onClick={(ev) => {
                            ev.preventDefault();
                            ev.stopPropagation();
                            this.handleClose("html", true);
                        }}
                        value="html">HTML including Header Row</MenuItem>
                    <MenuItem
                        data-test={"item-tsv"}
                        dense={true}
                        onClick={(ev) => {
                            ev.preventDefault();
                            ev.stopPropagation();
                            this.handleClose("tsv");
                        }}
                        value="tsv">TSV</MenuItem>
                    <MenuItem
                        data-test={"item-tsv-headers"}
                        dense={true}
                        onClick={(ev) => {
                            ev.preventDefault();
                            ev.stopPropagation();
                            this.handleClose("tsv", true);
                        }}
                        value="tsv">TSV including Header Row</MenuItem>
                    <MenuItem
                        data-test={"item-xlsx"}
                        dense={true}
                        onClick={(ev) => {
                            ev.preventDefault();
                            ev.stopPropagation();
                            this.handleClose("xlsx");
                        }}
                        value="xlsx">XLSX</MenuItem>
                    <MenuItem
                        data-test={"item-xlsx-headers"}
                        dense={true}
                        onClick={(ev) => {
                            ev.preventDefault();
                            ev.stopPropagation();
                            this.handleClose("xlsx", true);
                        }}
                        value="xlsx">XLSX including Header Row</MenuItem>
                </Menu>
            </div>
        );
    }
}

ReportDownload.defaultProps = {
    disabled: false
};

ReportDownload.propTypes = {
    disabled: PropTypes.bool,
    onDownloadReport: PropTypes.func.isRequired
};

export default ReportDownload;